export default "__VITE_ASSET__D8hwn3lu__"